module.exports = __webpack_public_path__ + "img/fi-rr-cross-small-red.3b4e7208.svg";